import VersionUpdateWatcher from '@/components/layouts/VersionUpdateWatcher';
import RouteProviders from '@/providers/route-providers';
import { Spin } from 'antd';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export default function RootLayout() {
  return (
    <RouteProviders>
      <VersionUpdateWatcher />
      <Suspense fallback={<Spin spinning fullscreen />}>
        <Outlet />
      </Suspense>
    </RouteProviders>
  );
}
